// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"bb48c46d","431":"78956b2a","489":"4a3585d2","492":"cf9ce118","538":"97306628","608":"9c0cf9b7"}[chunkId] + ".chunk.js";
};